import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ringCentralRoutes from "ringCentralRoutes";
import Scrollbar from "react-scrollbars-custom";
import { TeamActionContext } from "store/contexts/teamActionContext";
import { useParams } from "react-router-dom";
import Navbar from "components/Navbars/Navbar";
import Sidebar from "components/Sidebar/Sidebar";
import sidebar_routes from "sidebar_routes";
import { TeamContext } from "store/contexts/teamContext";
import TeamService from "services/TeamService";

export default () => {
  const [ringCentralRoute] = useState([...ringCentralRoutes]);
  const [postId, setPostId] = useState();
  const { teamId } = useParams();
  const [mobileLeftSidebarOpen, setMobileLeftSidebarOpen] = useState(false);
  const [team, setTeam] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        var teamsResponse = await TeamService.getTeam(teamId);

        setTeam(teamsResponse.data.data[0]);
      } catch (e) {
        console.log(e);
      }
    })();
  }, [teamId]);

  const handleLeftSidebarDrawer = () => {
    setMobileLeftSidebarOpen(!mobileLeftSidebarOpen);
  };

  const switchRoutes = (
    <Switch>
      {ringCentralRoute.map((prop, key) => {
        return (
          <Route
            path={prop.layout + prop?.path}
            component={prop?.component}
            key={key}
            exact
          />
        );
      })}
      <Redirect from={`/ringCentral/teams/${teamId}`} to={`/ringCentral/noPost`} />
    </Switch>
  );

  return (
    <TeamContext.Provider
      value={{
        team,
      }}
    >
      <TeamActionContext.Provider
        value={{
          teamId,
          setPostId,
          postId,
        }}
      >
        <Navbar
          ringCentralPost={true}
          handleLeftSidebarDrawer={handleLeftSidebarDrawer}
        />
        <Sidebar
          open={mobileLeftSidebarOpen}
          routes={sidebar_routes}
          closeLeftDrawer={handleLeftSidebarDrawer}
        />
        <div className="dashboard ringCentralPage">
          <Scrollbar>
            <div className="content">
              <div className="row justify-content-center ringCentralContent">
                {switchRoutes}
              </div>
            </div>
          </Scrollbar>
        </div>
      </TeamActionContext.Provider>
    </TeamContext.Provider>
  );
};
